
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexjI1wPGrUGRMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/index.vue?macro=true";
import { default as loadinglSh3U1gTodMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/loading.vue?macro=true";
import { default as maintenanceQm5MkItIfZMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/maintenance.vue?macro=true";
import { default as abouthmakt5vSR5Meta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/about.vue?macro=true";
import { default as accountuWXuk7skG6Meta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/account.vue?macro=true";
import { default as indexwyvOkJjHYtMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/index.vue?macro=true";
import { default as new_45resultsj4MbTzaqiFMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/new-results.vue?macro=true";
import { default as _91id_93nGIsLTu87bMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/record/[id].vue?macro=true";
import { default as _91id_935Nn7hhpzfXMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/results/[id].vue?macro=true";
import { default as search0E2YjhAP6kMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/search.vue?macro=true";
import { default as starredhjGCT3I7AZMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/starred.vue?macro=true";
import { default as _91id_93GR0uoLx3ZCMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/balance/[id].vue?macro=true";
import { default as indexMgaLD2tv4GMeta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/index.vue?macro=true";
import { default as _91id_93GByQF7VzC7Meta } from "/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/results/[id].vue?macro=true";
export default [
  {
    name: "index___en___default",
    path: "/",
    meta: indexjI1wPGrUGRMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexjI1wPGrUGRMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/index.vue")
  },
  {
    name: "index___bg",
    path: "/bg",
    meta: indexjI1wPGrUGRMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/index.vue")
  },
  {
    name: "loading___en___default",
    path: "/loading",
    meta: loadinglSh3U1gTodMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/loading.vue")
  },
  {
    name: "loading___en",
    path: "/en/loading",
    meta: loadinglSh3U1gTodMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/loading.vue")
  },
  {
    name: "loading___bg",
    path: "/bg/loading",
    meta: loadinglSh3U1gTodMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/loading.vue")
  },
  {
    name: "maintenance___en___default",
    path: "/maintenance",
    meta: maintenanceQm5MkItIfZMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/maintenance.vue")
  },
  {
    name: "maintenance___en",
    path: "/en/maintenance",
    meta: maintenanceQm5MkItIfZMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/maintenance.vue")
  },
  {
    name: "maintenance___bg",
    path: "/bg/maintenance",
    meta: maintenanceQm5MkItIfZMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/maintenance.vue")
  },
  {
    name: "portal-corporate-about___en___default",
    path: "/about",
    meta: abouthmakt5vSR5Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/about.vue")
  },
  {
    name: "portal-corporate-about___en",
    path: "/en/about",
    meta: abouthmakt5vSR5Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/about.vue")
  },
  {
    name: "portal-corporate-about___bg",
    path: "/bg/about",
    meta: abouthmakt5vSR5Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/about.vue")
  },
  {
    name: "portal-corporate-account___en___default",
    path: "/account",
    meta: accountuWXuk7skG6Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/account.vue")
  },
  {
    name: "portal-corporate-account___en",
    path: "/en/account",
    meta: accountuWXuk7skG6Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/account.vue")
  },
  {
    name: "portal-corporate-account___bg",
    path: "/bg/account",
    meta: accountuWXuk7skG6Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/account.vue")
  },
  {
    name: "home___en___default",
    path: "/home",
    meta: indexwyvOkJjHYtMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/index.vue")
  },
  {
    name: "home___en",
    path: "/en/home",
    meta: indexwyvOkJjHYtMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/index.vue")
  },
  {
    name: "home___bg",
    path: "/bg/home",
    meta: indexwyvOkJjHYtMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/index.vue")
  },
  {
    name: "portal-corporate-new-results___en___default",
    path: "/new-results",
    meta: new_45resultsj4MbTzaqiFMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/new-results.vue")
  },
  {
    name: "portal-corporate-new-results___en",
    path: "/en/new-results",
    meta: new_45resultsj4MbTzaqiFMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/new-results.vue")
  },
  {
    name: "portal-corporate-new-results___bg",
    path: "/bg/new-results",
    meta: new_45resultsj4MbTzaqiFMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/new-results.vue")
  },
  {
    name: "portal-corporate-record-id___en___default",
    path: "/record/:id()",
    meta: _91id_93nGIsLTu87bMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/record/[id].vue")
  },
  {
    name: "portal-corporate-record-id___en",
    path: "/en/record/:id()",
    meta: _91id_93nGIsLTu87bMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/record/[id].vue")
  },
  {
    name: "portal-corporate-record-id___bg",
    path: "/bg/record/:id()",
    meta: _91id_93nGIsLTu87bMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/record/[id].vue")
  },
  {
    name: "portal-corporate-results-id___en___default",
    path: "/results/:id()",
    meta: _91id_935Nn7hhpzfXMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/results/[id].vue")
  },
  {
    name: "portal-corporate-results-id___en",
    path: "/en/results/:id()",
    meta: _91id_935Nn7hhpzfXMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/results/[id].vue")
  },
  {
    name: "portal-corporate-results-id___bg",
    path: "/bg/results/:id()",
    meta: _91id_935Nn7hhpzfXMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/results/[id].vue")
  },
  {
    name: "portal-corporate-search___en___default",
    path: "/search",
    meta: search0E2YjhAP6kMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/search.vue")
  },
  {
    name: "portal-corporate-search___en",
    path: "/en/search",
    meta: search0E2YjhAP6kMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/search.vue")
  },
  {
    name: "portal-corporate-search___bg",
    path: "/bg/search",
    meta: search0E2YjhAP6kMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/search.vue")
  },
  {
    name: "portal-corporate-starred___en___default",
    path: "/starred",
    meta: starredhjGCT3I7AZMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/starred.vue")
  },
  {
    name: "portal-corporate-starred___en",
    path: "/en/starred",
    meta: starredhjGCT3I7AZMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/starred.vue")
  },
  {
    name: "portal-corporate-starred___bg",
    path: "/bg/starred",
    meta: starredhjGCT3I7AZMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/corporate/starred.vue")
  },
  {
    name: "portal-otp-patient-balance-id___en___default",
    path: "/balance/:id()",
    meta: _91id_93GR0uoLx3ZCMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/balance/[id].vue")
  },
  {
    name: "portal-otp-patient-balance-id___en",
    path: "/en/balance/:id()",
    meta: _91id_93GR0uoLx3ZCMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/balance/[id].vue")
  },
  {
    name: "portal-otp-patient-balance-id___bg",
    path: "/bg/balance/:id()",
    meta: _91id_93GR0uoLx3ZCMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/balance/[id].vue")
  },
  {
    name: "otp-home___en___default",
    path: "/otp-home",
    meta: indexMgaLD2tv4GMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/index.vue")
  },
  {
    name: "otp-home___en",
    path: "/en/otp-home",
    meta: indexMgaLD2tv4GMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/index.vue")
  },
  {
    name: "otp-home___bg",
    path: "/bg/otp-home",
    meta: indexMgaLD2tv4GMeta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/index.vue")
  },
  {
    name: "otp-results___en___default",
    path: "/otp-results/:id",
    meta: _91id_93GByQF7VzC7Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/results/[id].vue")
  },
  {
    name: "otp-results___en",
    path: "/en/otp-results/:id",
    meta: _91id_93GByQF7VzC7Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/results/[id].vue")
  },
  {
    name: "otp-results___bg",
    path: "/bg/otp-results/:id",
    meta: _91id_93GByQF7VzC7Meta || {},
    component: () => import("/Users/alexandarvalov/Documents/GitHub/Milab/pages/portal/otp-patient/results/[id].vue")
  }
]